import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../../../../shared/queries';
import { handleError } from '../../../../../ui/err/handleError';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';

export default function useGetShipmentHistory(params: { mac: string }) {
  return useQuery({
    ...queries.shipment.byMac(params),
    select: (data) => data.data,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
